import React from "react";
import { formatPrice } from "../../lib/api";

const PackSizeSelector = ({ bundles, packSlug, onChange }) => (
  <div className="mt-8" data-testid="pack-size-selector">
    <div className="flex items-center justify-between mb-3">
      <p className="overline">Pack · Build the rotation</p>
      <span className="mono text-xs text-mute">Save up to 17%</span>
    </div>
    <div className="grid grid-cols-3 gap-2">
      {bundles.map((b) => {
        const active = packSlug === b.slug;
        return (
          <button
            key={b.slug}
            type="button"
            onClick={() => onChange(b.slug)}
            className={`relative text-left p-3 border transition-colors ${
              active
                ? "bg-ink text-white border-ink"
                : "bg-white text-ink border-line hover:border-ink"
            }`}
            data-testid={`pack-option-${b.slug}`}
          >
            {b.featured && (
              <span
                className={`absolute -top-2 left-2 mono text-[9px] tracking-widest uppercase px-1.5 py-0.5 ${
                  active ? "bg-pritch-volt-trim text-ink" : "bg-ink text-white"
                }`}
              >
                Most picked
              </span>
            )}
            <p className="font-display uppercase text-lg leading-none">
              {b.pairs}
              <span className="text-xs ml-1 align-baseline">
                pair{b.pairs > 1 ? "s" : ""}
              </span>
            </p>
            <p className={`mono text-xs mt-2 ${active ? "text-white/70" : "text-mute"}`}>
              {formatPrice(b.price)}
            </p>
            {b.saving > 0 && (
              <p
                className={`text-[10px] tracking-widest uppercase mt-1 ${
                  active ? "text-pritch-volt-trim" : "text-ink"
                }`}
              >
                Save {formatPrice(b.saving)}
              </p>
            )}
          </button>
        );
      })}
    </div>
  </div>
);

export default PackSizeSelector;
